import React, { Component } from 'react'
import { HOME_LOCATION } from '../common/constants'

class NotFound extends Component {
  componentDidMount() {
    this.props.history.push(HOME_LOCATION)
  }
  render() {
    return <div className='app-NotFound'></div>
  }
}

export default NotFound
